function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M.265 5.562h4.762",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.52916
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.59.265l1.058 1.058-2.91 2.91H.68V3.175z",
  clipRule: "evenodd",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.52916
}));

function SvgIconEditSimple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22.021,
    viewBox: "0 0 5.292 5.826",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgIconEditSimple;